'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'circle-dollar';
var width = 512;
var height = 512;
var aliases = ["dollar-circle","usd-circle"];
var unicode = 'f2e8';
var svgPathData = ['M32 256a224 224 0 1 0 448 0 224 224 0 1 0 -448 0zm152-41.4c0-30.1 24.4-54.6 54.6-54.6l1.4 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-57.4 0c-12.5 0-22.6 10.1-22.6 22.6 0 11.2 8.3 20.7 19.4 22.3l45.8 6.5c26.9 3.8 46.8 26.9 46.8 54 0 30.1-24.4 54.6-54.6 54.6l-1.4 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l65.4 0c12.5 0 22.6-10.1 22.6-22.6 0-11.2-8.3-20.7-19.4-22.3l-45.8-6.5c-26.9-3.8-46.8-26.9-46.8-54z', 'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM238.6 160c-30.1 0-54.6 24.4-54.6 54.6 0 27.2 20 50.2 46.8 54l45.8 6.5c11.1 1.6 19.4 11.1 19.4 22.3 0 12.5-10.1 22.6-22.6 22.6L208 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 1.4 0c30.1 0 54.6-24.4 54.6-54.6 0-27.1-20-50.2-46.8-54l-45.8-6.5c-11.1-1.6-19.4-11.1-19.4-22.3 0-12.5 10.1-22.6 22.6-22.6l57.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-1.4 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;